var _process$env$NEXT_PUB;

export var config = {
  api: {
    baseUrl: (_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_API_BASE_URL) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : ''
  },
  websocketPort: process.env.NEXT_PUBLIC_WEBSOCKETS_PORT ? Number(process.env.NEXT_PUBLIC_WEBSOCKETS_PORT) : 9000,
  googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY
};